import DataUploadsPage from './DataUploadsPage';

export { default as DataReviewPage } from './DataReviewPage';
export { default as NewDataUploadPage } from './NewDataUploadPage';
export { default as MatchHeadersPage } from './MatchHeadersPage';
export { default as MatchHeadersProvider } from './MatchHeadersProvider';

export default DataUploadsPage;
